import { INVENTORY_MODULE } from "@/api_framework/api_config";
import {
  IGoodInventoryProductBadInventoryFilterResponseData,
  IGoodInventoryProductFilterBody,
  IGoodInventoryProductFilterResponse,
  IGoodInventoryProductFilterResponseData,
} from "@/api_framework/api_modals/Inventory";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { setLoading } from "@/app_redux/reducers/loading_reducer";

AxiosCurlirize(axios, () => {});
type InventoryTaxCreateAPIResponse = { status: boolean; message: string };

export const useProductFilterAPI = () => {
  const configuration = useConfiguration();
  const [data, setData] = useState<
    IGoodInventoryProductFilterResponseData | IGoodInventoryProductBadInventoryFilterResponseData
  >();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  // const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (filterBody: IGoodInventoryProductFilterBody, params: string, page_number: number, page_size: number) => {
      dispatch(
        setLoading({
          key: "isInventoryProductGoodInventory",
          status: true,
        }),
      );
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: InventoryTaxCreateAPIResponse = await axios
          .post(
            `${INVENTORY_MODULE?.PRODUCT_FILTER?.baseURL}?selected_tab=${params}&page_number=${page_number}&page_size=${page_size}`,
            filterBody,
            {
              headers: {
                Authorization: `${accessToken}`,
                "Content-Type": "application/json",
              },
            },
          )
          .then((res: AxiosResponse<IGoodInventoryProductFilterResponse>) => {
            if (res.data.status === true) {
              setData(res.data.data);
              dispatch(
                setLoading({
                  key: "isInventoryProductGoodInventory",
                  status: false,
                }),
              );
              return { status: true, message: "batch" };
            } else {
              setData(null);
              dispatch(
                setLoading({
                  key: "isInventoryProductGoodInventory",
                  status: false,
                }),
              );
              return { status: false, message: "product_not_filtered" };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            dispatch(
              setLoading({
                key: "isInventoryProductGoodInventory",
                status: false,
              }),
            );
            // captureError(e)
            return { status: false, message: "product_not_filtered" };
          });
        return response;
      } catch (e: any) {
        dispatch(
          setLoading({
            key: "isInventoryProductGoodInventory",
            status: false,
          }),
        );
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { data, execute };
};
